// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function BellRingingIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M28 8.887a1 1 0 0 1-1.348-.427 11.766 11.766 0 0 0-4.182-4.614 1 1 0 1 1 1.068-1.692 13.932 13.932 0 0 1 4.89 5.386A1 1 0 0 1 28 8.887ZM4.464 9a1 1 0 0 0 .887-.54c.955-1.886 2.4-3.48 4.183-4.614a1 1 0 1 0-1.068-1.692 13.933 13.933 0 0 0-4.89 5.386A1 1 0 0 0 4.464 9Zm23.262 12.992A2 2 0 0 1 26 25h-5.1a5 5 0 0 1-9.8 0H6a2 2 0 0 1-1.724-3.008C5.403 20.05 6 17.285 6 14a10 10 0 1 1 20 0c0 3.284.598 6.047 1.726 7.992ZM18.828 25h-5.655a3 3 0 0 0 5.655 0ZM26 23c-1.33-2.284-2-5.311-2-9a8 8 0 1 0-16 0c0 3.69-.673 6.718-2 9h20Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
